import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { LoadingActions } from './loading.actions';
import { LoadingService } from '../../components/loading/loading.service';

@Injectable()
export class LoadingEffects {
  constructor(private actions$: Actions, private loadingService: LoadingService) {}

  loadingStart$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LoadingActions.loading_start),
        map(() => {
          return this.loadingService.showLoader();
        })
      ),
    { dispatch: false }
  );

  loadingEnd$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LoadingActions.loading_end),
        map(() => {
          return this.loadingService.hideLoader();
        })
      ),
    { dispatch: false }
  );
}
